// src/pages/Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate }    from 'react-router-dom';
import { auth }           from '../firebase.js';
import { useAuth }        from '../context/AuthContext.js';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  updateProfile
} from 'firebase/auth';
import {
  Card, Form, Button, Alert,
  Spinner, Container, Row, Col
} from 'react-bootstrap';

export default function Login() {
  const navigate = useNavigate();
  const { user } = useAuth();        // auth state + profile
  const [isRegister, setIsRegister] = useState(false);

  // form fields
  const [email, setEmail]             = useState('');
  const [password, setPassword]       = useState('');
  const [confirmPassword, setConfirm] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError]             = useState('');
  const [loading, setLoading]         = useState(false);

  // redirect when user state changes
  useEffect(() => {
    if (user?.uid) {
      if (user.isAdmin) {
        navigate('/admin/users', { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    }
  }, [user, navigate]);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');

    // registration validations
    if (isRegister) {
      if (!displayName.trim()) {
        setError('Informe seu nome para cadastro');
        return;
      }
      if (password !== confirmPassword) {
        setError('As senhas não coincidem');
        return;
      }
    }

    setLoading(true);
    try {
      if (isRegister) {
        await createUserWithEmailAndPassword(auth, email, password);
        await updateProfile(auth.currentUser, { displayName: displayName.trim() });
      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }
      // navigation handled in useEffect
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="vh-100 d-flex align-items-center justify-content-center">
      <Row className="w-100">
        <Col md={{ span: 6, offset: 3 }} lg={{ span: 4, offset: 4 }}>
          <Card className="shadow-sm">
            <Card.Body>
              <Card.Title className="text-center mb-4">
                {isRegister ? 'Criar Conta' : 'Entrar'}
              </Card.Title>

              {error && <Alert variant="danger">{error}</Alert>}

              <Form onSubmit={handleSubmit}>
                {isRegister && (
                  <Form.Group className="mb-3">
                    <Form.Label>Nome</Form.Label>
                    <Form.Control
                      type="text"
                      required
                      value={displayName}
                      onChange={e => setDisplayName(e.target.value)}
                    />
                  </Form.Group>
                )}

                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    required
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Senha</Form.Label>
                  <Form.Control
                    type="password"
                    required
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                  />
                </Form.Group>

                {isRegister && (
                  <Form.Group className="mb-3">
                    <Form.Label>Confirmar Senha</Form.Label>
                    <Form.Control
                      type="password"
                      required
                      value={confirmPassword}
                      onChange={e => setConfirm(e.target.value)}
                    />
                  </Form.Group>
                )}

                <div className="d-grid mb-2">
                  <Button variant="primary" type="submit" disabled={loading}>
                    {loading
                      ? <><Spinner animation="border" size="sm" /> Carregando...</>
                      : isRegister ? 'Cadastrar' : 'Entrar'}
                  </Button>
                </div>
              </Form>

              <hr />

              <div className="text-center">
                {isRegister ? 'Já tem conta? ' : 'Ainda não tem conta? '}
                <Button
                  variant="link"
                  size="sm"
                  onClick={() => setIsRegister(r => !r)}
                >
                  {isRegister ? 'Entrar' : 'Cadastre-se'}
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
